import React from 'react'
import './footer.scss'
import logo from '../../assets/logo.png'
import QRCode from '../../assets/QRCode.png'

function Footer() {
  return <div className="footer">
    <div className="footer_slogan_container">
      <img alt="logo" className="banner_logo" src={logo}></img>
      <h1 className="banner_title">一站式3D展销升级云服务</h1>
      <p>Copyright © 2015- 2019 OppenFuture Technologies 京ICP备13003562号</p>
      <p>©2017 OppenFuture Technologies</p>
    </div>

    <div class="footer_QRCode_container">
      <img src={QRCode} className="footer_QRCode"/>
      <p>扫一扫 添加业务咨询微信<br/>1对1专属免费咨询服务</p>
    </div>

    <div class="footer_mobile_content">
      <h1>Hololux ™光场复现</h1>
      <p>©2020 OppenFuture Technologies</p>
    </div>
  </div>
}

export default Footer